module.exports = __webpack_public_path__ + "media/img/alufelgi@3x-dark-c1f6d15e.svg";